import Entity from "../entity";
export default class UploadContent extends Entity<number>{
    filefrom:string='';
    filecatalog:string='';
    filecatalog2:string='';
    notes:string= '';
    fileImport:Array<any>=[];
    tags:Array<any>=[];
}